import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="6.8mm"
    height={22.391}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 36467 31770"
    {...props}
  >
    <path
      d="M36467 2692V0H0v2692h4318v16568h-416v1655c-43 87-167 280-466 457l-234 138v3291h72c-34 55-72 103-117 141-155 96-304 206-440 323-444 387-1565 1736-1392 3326 139 1290 1041 2431 2376 2986 234 88 612 193 1080 193 456 0 909-100 1358-303 1185-581 2000-1682 2128-2876 172-1590-948-2940-1394-3326-136-117-282-227-440-323-45-38-83-86-117-141h72v-3291l-232-138c-304-179-425-375-466-454v-1658h-418V2692h12483v16568h-418v1655c-43 87-167 280-465 457l-235 138v3291h73c-33 55-71 103-117 141-153 96-301 206-437 323-447 387-1567 1736-1395 3326 138 1290 1044 2431 2376 2986 234 88 612 193 1080 193 458 0 910-100 1359-303 1184-581 2001-1682 2128-2876 172-1590-948-2940-1392-3326-139-117-285-227-440-323-45-38-84-86-117-141h71v-3291l-234-138c-301-179-425-375-466-454v-1658h-415V2692h12480v16568h-416v1655c-45 87-170 280-466 457l-233 138v3291h71c-33 55-71 103-117 141-155 96-304 206-440 323-446 387-1564 1736-1394 3326 138 1290 1043 2431 2378 2986 231 88 609 193 1077 193 459 0 912-100 1361-303 1185-581 1999-1682 2128-2876 170-1590-948-2940-1394-3326-136-117-284-227-440-323-45-38-84-86-117-141h71v-3291l-233-138c-302-179-426-375-466-454v-1658h-416V2692h4322z"
      style={{
        fill: "#231f20",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
